import { IndexedDBService } from "~/core/services/indexed-db-storage.service";
import { StorageService } from "~/core/services/storage.service";
import { CompanyService } from "~/core/services/company.service";
import { CookiePermissionService } from "~/core/services/cookie-permission.service";
import { PermissionService } from "~/pages/back-office/roles/services/permission.service";

export function initializeStorageApp(
  idb: IndexedDBService,
  storageS: StorageService,
  companyS: CompanyService,
  cookieService: CookiePermissionService,
  permissionService: PermissionService,
) {
  return async () => {
    try {
      await IndexedDBService.openDB();
      await StorageService.initializeCacheFromDB();
      await CompanyService.initializeCache();
      await permissionService.init();
      cookieService.init();
    } catch (error) {
      console.error("Erro na inicialização do initializeStorageApp:", error);
    }
  };
}
